
import {of as observableOf,  of ,  Observable } from 'rxjs';

import {first} from 'rxjs/operators';
import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../base-control/base-control.component";
import { TemplateService } from "../../../common/components/pdf-viewer/services/template.service";
import { LoaderService } from "../../../common/services/loader.service";
import { genId } from "../../../core/services/genId";
import { RuleCompiler } from "../../../flow/services/rule-compiler.service";
import { RuleEvaluationFn } from "../../../flow/models/flow.model";
import { ContextInteractionService } from '../../services/context-interaction.service';

@Component({
    selector: "flow-pdf-viewer",
    templateUrl: "./flow-pdf-viewer.component.html",
    styleUrls: ["./flow-pdf-viewer.component.scss"],
    standalone: false
})
export class FlowPdfViewerComponent extends BaseControlComponent implements OnInit {
    static componentName = "pdfviewercomponent";

    _compiledHeader: string = undefined;

    get compiledCustomHeader(): string {
        if (this._compiledHeader === undefined) {
            var rule = this.compiler.compileSyncRule<string>(this.componentData.config.pdfOptions.customHeader.expressionRule, this.componentContext, "") as RuleEvaluationFn<string>;
            this._compiledHeader = rule();
        }
        return this._compiledHeader;
    }


    get fileName(): string {
        if (!this.componentData.config) {
            this.componentData.config = { templateFile: "" };
        } else if (this.componentData.config && !this.componentData.config.templateFile) {
            this.componentData.config.templateFile = "";
        }
        return this.componentData.config.templateFile;
        
    }

    get html(): string {
        if (this.componentData.config.pdfDocument) {
            if (this.componentData.config.pdfDocument !== 'Context') {
                return `A rendered ${this.componentData.config.pdfDocument} pdf document will be shown`;
            } else {
                return `A rendered pdf document of type determined by context at ${this.componentData.config.pdfOptions.documentTypeContext} will be shown.`;
            }
            
        }
        return " ";
    }

    get documentType(): string {
        if (!this.componentData.config) {
            this.componentData.config = { pdfDocument: "" };
        } else if (this.componentData.config && !this.componentData.config.pdfDocument) {
            this.componentData.config.pdfDocument = "";
        }
        return this.componentData.config.pdfDocument;
    }



    pdfError: string = "";
    pdfData: any;
    pdfUrl: string;
    

    constructor(public readonly templateService: TemplateService,
                public readonly loader: LoaderService,
                public readonly compiler: RuleCompiler,
                public readonly contextService: ContextInteractionService)
    {
        super(contextService);
    }

    ngOnInit() {
        super.ngOnInit();
        if (!this.isEdit) {
            this.generatePdf();
        }
    }

    createPdf(): void {
        const blob = new Blob([this.pdfData], { type: "application/pdf" });
        const fileName = `${genId()}.pdf`;
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		link.click();
    }

    generatePdf(): void {
        this.loader.toggleLoader(true);
        this.templateService.generatePdf(this.componentContext, this.componentData.config).pipe(first()).subscribe((blob) => {
            this.pdfError = "";          
            this.pdfUrl = window.URL.createObjectURL(blob);
            this.pdfData = blob;
            this.loader.toggleLoader(false);
        }, (error) => {
            console.error(error);
            this.pdfError = error.error;
            this.loader.toggleLoader(false);
        });
    }
}
